import React from "react";
import { useNavigate } from "react-router-dom";

interface IProps {
    datas?: { idmarque: string; idmessage?:string}[];
    PathNamePrefixe?: string;
    currentValueIdMarque: string;
    currentValueIdMessage?:string;
}

const CpntNavigatorSociete: React.FC<IProps> = ({ datas, PathNamePrefixe, currentValueIdMarque,currentValueIdMessage}) => {
    const navigate = useNavigate();

    //const indexEan = datas?.findIndex(d => d.Ean === currentValueEan) ?? -1;
    const indexIdNotice = datas?.findIndex(d => d.idmarque?.toString().trim() === currentValueIdMarque?.toString().trim()
                    && (!currentValueIdMessage ||!d.idmessage || d.idmessage?.toString().trim() === currentValueIdMessage?.toString().trim())
                    )
                    ?? -1;


    const previous = () => {
        if (datas && indexIdNotice > 0) {
            const previousData = datas[indexIdNotice - 1];
            const pathPrefixe = PathNamePrefixe ?? `${"./"}${previousData?.idmarque ? `../` : ''}${previousData?.idmessage ? `../` : ''}`;
            navigate(`${pathPrefixe}${previousData?.idmarque}${previousData?.idmessage ? `/${previousData.idmessage}` : ''}`);
        }
    };

    const next = () => {
        if (datas && indexIdNotice < datas.length - 1) {
            const nextData = datas[indexIdNotice + 1];
            const pathPrefixe = PathNamePrefixe ?? `${"./"}${nextData?.idmarque ? `../` : ''}${nextData?.idmessage ? `../` : ''}` ;
            navigate(`${pathPrefixe}${nextData?.idmarque}${nextData?.idmessage ? `/${nextData.idmessage}` : ''}`);
        }
    };

    return (
        <>
            {datas && datas.length > 0 && (
                <div>
                    {indexIdNotice > 0 ? (
                        <i className="bi bi-arrow-left-square-fill App-icon-size-Big me-1 text-secondary Pointer" onClick={previous}></i>
                    ) : (
                        <i className="bi bi-arrow-left-square-fill App-icon-size-Big me-1 text-grey"></i>
                    )}
                    <span className="titreModule pb-2">
                        <i>{indexIdNotice + 1}</i>{`/${datas.length}`}
                    </span>
                    {indexIdNotice < datas.length - 1 ? (
                        <i className="bi bi-arrow-right-square-fill App-icon-size-Big ms-1 text-secondary Pointer" onClick={next}></i>
                    ) : (
                        <i className="bi bi-arrow-right-square-fill App-icon-size-Big ms-1 text-grey"></i>
                    )}
                </div>
            )}
        </>
    );
};

export default CpntNavigatorSociete;
